var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoMapamundi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.333,
    cy: 29.2661,
    r: 14.5,
    stroke: "#444444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1012 46.766C40.8887 48.8736 37.0458 50.0993 32.9167 50.0993C21.6409 50.0993 12.5 40.9585 12.5 29.6827C12.5 21.7032 17.0776 14.7929 23.75 11.4346",
    stroke: "#0099CC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.083 15.9326C31.8052 17.0437 43.7497 23.4326 42.9163 40.0993",
    stroke: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.167 33.016L41.667 17.1826",
    stroke: "#444444"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.167 40.0994L46.667 24.2661",
    stroke: "#444444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42.1826C35.5341 40.288 22.9126 32.6769 23.6687 18.4326",
    stroke: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMapamundi);
export default __webpack_public_path__ + "static/media/ico_mapamundi.d7470ca1002bafd1ebb4141502fb1170.svg";
export { ForwardRef as ReactComponent };